import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'app-support-configuration',
  templateUrl: './support-configuration.component.html',
  styleUrl: './support-configuration.component.scss'
})
export class SupportConfigurationComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;


  protected readonly TabNames = TabNames;
  selectedButton: string;
  supportConfiguration: any;
  testCompanies: string[] = [];
  emailConfiguration : EmailConfiguration;

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.selectedButton = TabNames.testCompanies;
    this.supportConfiguration = this.magicLinkModel.fieldValues['SupportConfiguration'];
    this.testCompanies = this.supportConfiguration?.testCompanyIds ?? [];
    this.emailConfiguration = this.supportConfiguration?.emailConfiguration;
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

  onClickButton(selectedButton: string) {
    this.selectedButton = selectedButton;
  }

}
export class TabNames {
  static readonly testCompanies = 'Test Companies';
  static readonly emailNotificationConfiguration = "Email Configuration";
}
export interface EmailConfiguration {
  numberOfDaysToRemindForComments : number;
}
